import { ApolloClient, InMemoryCache } from '@apollo/client';
import { DeviceType } from '@landr/react-core';
import { CONFIG } from '../config';
import { link } from './link';
import { cacheConfig } from './cache';

export const apolloClient = (deviceType: DeviceType) =>
    new ApolloClient({
        uri: CONFIG.VITE_GRAPHQL_API,
        cache: new InMemoryCache(cacheConfig),
        link: link(deviceType),
    });
